if (!customElements.get('nc-set-story')) {
  class NCSetStory extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[data-video]');
      this.button = this.querySelector('[data-playback]');
      this.status = this.querySelector('[data-video-status]');
      if (!this.video || !this.button) return;

      this.abort = new AbortController();
      this.mobile = matchMedia('(max-width: 720px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.pausedByUser = false;
      this.inView = false;
      this.onViewportChange = () => this.selectSource();
      this.onMotionChange = () => {
        if (this.reducedMotion.matches) this.video.pause();
        else this.maybePlay();
      };
      this.mobile.addEventListener('change', this.onViewportChange);
      this.reducedMotion.addEventListener('change', this.onMotionChange);
      this.button.addEventListener('click', () => this.togglePlayback(), {signal: this.abort.signal});
      this.video.addEventListener('playing', () => this.updateButton(), {signal: this.abort.signal});
      this.video.addEventListener('pause', () => this.updateButton(), {signal: this.abort.signal});
      this.video.addEventListener('error', () => {
        this.status.hidden = false;
        this.button.textContent = 'Retry video';
        this.button.setAttribute('aria-label', 'Retry video');
      }, {signal: this.abort.signal});

      this.selectSource();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (this.inView) this.maybePlay();
          else this.video.pause();
        }, {threshold: 0.25});
        this.observer.observe(this);
      } else {
        this.inView = true;
        this.maybePlay();
      }
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.onViewportChange);
      this.reducedMotion?.removeEventListener('change', this.onMotionChange);
      this.video?.pause();
    }

    selectSource() {
      const url = this.mobile.matches ? this.video.dataset.mobileSrc : this.video.dataset.desktopSrc;
      const poster = this.mobile.matches ? this.video.dataset.mobilePoster : this.video.dataset.desktopPoster;
      if (!url || this.video.getAttribute('src') === url) return;
      this.video.pause();
      this.status.hidden = true;
      if (poster) this.video.poster = poster;
      this.video.src = url;
      this.video.load();
      this.maybePlay();
    }

    async maybePlay(manual = false) {
      if (!this.inView || (!manual && (this.pausedByUser || this.reducedMotion.matches))) return;
      try {
        await this.video.play();
        this.status.hidden = true;
      } catch {
        if (manual) this.status.hidden = false;
        this.updateButton();
      }
    }

    togglePlayback() {
      if (this.video.error) {
        this.video.load();
        this.pausedByUser = false;
        this.maybePlay(true);
      } else if (this.video.paused) {
        this.pausedByUser = false;
        this.maybePlay(true);
      } else {
        this.pausedByUser = true;
        this.video.pause();
      }
    }

    updateButton() {
      const playing = !this.video.paused;
      this.button.textContent = playing ? 'Pause' : 'Play';
      this.button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      this.button.setAttribute('aria-pressed', String(playing));
    }
  }

  customElements.define('nc-set-story', NCSetStory);
}
